import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIBox from 'UIComponents/layout/UIBox';
// @ts-expect-error Could not find a declaration file for module
import useMediaQuery from '../../hooks/useMediaQuery';
import { device } from '../../constants/StyledComponentConstants';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CenteredUIBox = styled(UIBox).withConfig({
  displayName: "WizardProgressSection__CenteredUIBox",
  componentId: "sc-190zfrj-0"
})(["text-align:center;color:white;padding:10px 0;"]);
const WizardProgressSection = ({
  noteMessage,
  noteOptions,
  onProgressStepClick,
  linkMessageLine1,
  linkMessageLine2,
  link
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  return (
    /*#__PURE__*/
    // @ts-expect-error Untyped
    _jsxs(CenteredUIBox, {
      onClick: isMobile ? onProgressStepClick : null,
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: noteMessage,
        options: noteOptions
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UIRouterLink, {
        className: "link",
        onClick: onProgressStepClick,
        to: link,
        use: "on-dark",
        children: /*#__PURE__*/_jsxs("big", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: linkMessageLine1
          }), linkMessageLine2 && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
              message: linkMessageLine2
            })]
          })]
        })
      })]
    })
  );
};
export default WizardProgressSection;